/** Controlled debug flag for Explore – enable via VITE_EXPLORE_DEBUG=true */
export const EXPLORE_DEBUG =
  import.meta.env.DEV || import.meta.env.VITE_EXPLORE_DEBUG === "true";
